import { ArrowLeft, ArrowRight } from "lucide-react"
import { primaryActionClasses } from "@/components/activation/styles"

export function StepNavigation({ stepNumber, canContinue, isSubmitting, onBack, continueLabel = "Continue" }) {
  const disabled = !canContinue || isSubmitting
  return (
    <div className="mt-12 flex items-center justify-between border-t border-border pt-8">
      {stepNumber > 1 ? (
        <button
          type="button"
          onClick={onBack}
          className="flex items-center gap-2 px-4 py-2 text-sm font-medium text-muted-foreground transition-colors hover:text-foreground"
        >
          <ArrowLeft className="h-4 w-4" /> Back
        </button>
      ) : <span />}

      <button
        type="submit"
        disabled={disabled}
        className={primaryActionClasses(disabled, "flex items-center gap-2")}
      >
        {continueLabel}
        <ArrowRight className="h-4 w-4" />
      </button>
    </div>
  )
}
